import BaseTransition from './baseTransition'
import gsap from 'gsap'

export default class Fade extends BaseTransition {
  hideLoader() {
    return new Promise((resolve) => {
      gsap.to(this.fade, {
        opacity: 0,
        duration: 0.5,
        ease: 'expo.out',
        onComplete: () => {
          resolve()
        }
      })
    })
  }

  showLoader() {
    return new Promise((resolve) => {
      gsap.to(this.fade, {
        opacity: 1,
        duration: 0.5,
        ease: 'expo.out',
        onComplete: () => {
          resolve()
        }
      })
    })
  }

  getElems() {
    this.fade = document.querySelector('.fade')
  }
}
